import { defineNuxtRouteMiddleware, useCookie, useNuxtApp } from "#app";
import { v4 } from "uuid";

export default defineNuxtRouteMiddleware(() => {
  const { $config, $posthogIdentifier } = useNuxtApp();

  const cookies = useCookie<Record<string, string>>(
    `ph_${$config.public.posthogPublicKey}_posthog`,
  );
  let distinctId: string | undefined = cookies.value?.distinct_id;
  if (!distinctId) {
    distinctId = v4();
    cookies.value = {
      distinct_id: distinctId,
    };
  } else {
    distinctId = cookies.value.distinct_id;
  }

  $posthogIdentifier.value = distinctId!;
});
